/**
 * Returns a sorting function based on whether the order is ascending or descending
 * @param {*} order The order to sort the data ("asc" or "desc")
 * @param {*} orderBy The column to sort the data
 * @param {*} desc The function that compares the data
 * @returns {function} The sorting function
 */

export const TableOrdering = Object.freeze({
  ASC: "asc",
  DESC: "desc",
});

export function getSorting(order, orderBy, desc) {
  return order === TableOrdering.DESC
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}

export function stableSort(dataArray, comparison) {
  const stabilizedThis = dataArray.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparison(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

export function createContent(rows, headers, order, orderBy, desc) {
  const rowsCopy = [];
  var obj = {};
  for (var i = 0; i < rows.length; i++) {
    for (var j = 0; j < headers.length; j++) {
      obj[headers[j]] = rows[i][headers[j]];
    }
    rowsCopy.push(obj);
    obj = {};
  }
  return stableSort(rowsCopy, getSorting(order, orderBy, desc));
}
